import Home from './pages/home';
import { GlobalStyle } from './style/GlobalStyles';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, useGSAP);

function App() {
  return (
    <>
    <GlobalStyle />
    <Router>
    <Routes>
        <Route path='/' element={<Home/>} />
      </Routes>

    </Router>
    </>
  );
}

export default App;
